import { combineReducers } from "redux";
import evaluationDependencyReducer from "./dependencyReducer";
import dynamicLayoutReducer from "./dynamicLayoutReducer";
import evaluationTypeReducer from "./evaluationTypeReducer";
import lifecycleReducer from "./lifecycleReducer";
import loadingEntitiesReducer from "./loadingEntitiesReducer";
import nameIteratorReducer from "./nameIteratorReducer";
import evaluatedTreeReducer from "./treeReducer";
import type { EvaluationDependencyState } from "./dependencyReducer";
import type { DynamicLayoutState } from "./dynamicLayoutReducer";
import type { EvaluationType } from "./evaluationTypeReducer";
import type { LifecycleState } from "./lifecycleReducer";
import type { LoadingEntitiesState } from "./loadingEntitiesReducer";
import type { EvaluatedTreeState } from "./treeReducer";

export interface EvaluationsState {
  tree: EvaluatedTreeState;
  dependencies: EvaluationDependencyState;
  loadingEntities: LoadingEntitiesState;
  evaluationType: EvaluationType;
  lifecycle: LifecycleState;
  dynamicLayout: DynamicLayoutState;
  nameIterator: number;
}

export default combineReducers({
  tree: evaluatedTreeReducer,
  dependencies: evaluationDependencyReducer,
  loadingEntities: loadingEntitiesReducer,
  evaluationType: evaluationTypeReducer,
  lifecycle: lifecycleReducer,
  dynamicLayout: dynamicLayoutReducer,
  nameIterator: nameIteratorReducer,
});
